import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { venues } from "@/components/essex/venueData";

export default function VenueShowcase() {
  return (
    <>
      {/* Venue Marquee */}
      <div className="bg-[#0A0908] py-8 overflow-hidden" data-testid="venue-marquee">
        <Marquee speed={30} gradient={false} pauseOnHover>
          {[...venues, ...venues].map((v, i) => (
            <span
              key={i}
              className="font-serif text-5xl md:text-7xl lg:text-8xl text-white/[0.04] mx-8 whitespace-nowrap select-none"
            >
              {v.name}
            </span>
          ))}
        </Marquee>
      </div>

      {/* Venue Showcase */}
      <section
        id="venues"
        data-testid="venue-showcase-section"
        className="bg-[#0A0908] py-24 md:py-32"
      >
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mb-12"
          >
            <p className="text-xs tracking-[0.2em] uppercase text-[#C2A878] font-sans mb-4">
              Essex Wedding Venues
            </p>
            <h2
              data-testid="venues-heading"
              className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight font-light text-[#F5F5F0]"
            >
              We know Essex venues inside out
            </h2>
            <p className="mt-4 text-base text-[#A19D94] font-sans leading-relaxed">
              We've photographed and filmed at all of these venues (and loads more). We know every
              angle, every lighting sweet spot, and every hidden corner. Click any venue to see
              our work there.
            </p>
          </motion.div>

          {/* Smaller Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
            {venues.map((venue, i) => (
              <motion.div
                key={venue.name}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
              >
                <Link
                  to={`/${venue.slug}`}
                  data-testid={`venue-card-${venue.name.toLowerCase().replace(/\s+/g, '-')}`}
                  className="venue-card relative group block aspect-[4/3] border border-white/[0.06] overflow-hidden"
                >
                  <img
                    src={venue.image}
                    alt={`${venue.name} wedding venue Essex`}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                    <h3 className="font-serif text-sm md:text-base lg:text-lg text-[#F5F5F0] tracking-tight leading-tight">
                      {venue.name}
                    </h3>
                    <p className="text-[10px] text-[#C2A878] font-sans mt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      View photos & films
                    </p>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
